export default __webpack_public_path__ + "static/media/10_tag_outdoor-bath.eeeb32ec.svg";